import type { FC } from 'react'
import {
  Desktop,
  MediaContextProvider,
  Mobile,
  Tablet
} from '@/components/atoms/media'
import ProductListing from './productListing/productListingRedesign'
import type { ProductListingFetcher } from '@/components/organisms/productListing/productListingFetcher'
import { ListingData } from 'types/listingData'
import { BridgeProduct } from '@/types/bridgeProduct'
import type { ProductCardColors } from '../atoms/productCardPlaceholder'
import type { ProductCardMode } from './productCard/productCardMode'
import { ProductCardActionType } from './productCard/productCard'
import { HomeBanner } from '@/network/graphql.g'

type ProductsContainerProps = {
  data: ListingData<BridgeProduct>
  action?: ProductCardActionType
  showPager: boolean
  fetcher: ProductListingFetcher
  maxWidth?: ProductsContainerResponsiveData<number | string>
  itemsPerRow?: ProductsContainerResponsiveData<number>
  list: string
  colors?: ProductCardColors
  indentText?: boolean
  mode?: ProductCardMode
  useFitIn?: boolean
  isInSaleCampaign?: boolean
  isParfumCampaign?: boolean
  campaignTitle?: string
  campaignId?: string
  isCampaignForCountDown?: boolean
  isCampaign?: boolean
  categoryProductBanners?: HomeBanner[]
  desktopImageUrl?: string
  mobileImageUrl?: string
  description?: string
} & Rest

type ProductsContainerResponsiveData<T> = {
  wide?: T
  desktop: T
  tablet: T
  mobile: T
}

const ProductsContainerRedesign: FC<ProductsContainerProps> = ({
  data,
  action,
  fetcher,
  maxWidth,
  list,
  itemsPerRow = { desktop: 4, tablet: 3, mobile: 2 },
  colors,
  indentText,
  mode,
  useFitIn = false,
  isInSaleCampaign,
  isParfumCampaign,
  campaignTitle,
  campaignId,
  isCampaignForCountDown,
  isCampaign,
  categoryProductBanners,
  desktopImageUrl,
  mobileImageUrl,
  description
}) => {
  const productListingProps = {
    data,
    products: data,
    action,
    fetcher,
    listData: data,
    productListingFetcher: fetcher,
    maxWidth,
    list,
    colors,
    indentText,
    mode,
    useFitIn,
    isInSaleCampaign,
    isParfumCampaign,
    campaignTitle,
    campaignId,
    isCampaignForCountDown,
    isCampaign,
    categoryProductBanners,
    desktopImageUrl,
    mobileImageUrl,
    description
  }

  return (
    <>
      <MediaContextProvider>
        <Desktop>
          <ProductListing
            itemsPerRow={itemsPerRow.desktop}
            listingBannerRowProperty="row"
            listingBannerSizeProperty="size"
            listingBannerImageProperty="desktopImage"
            {...productListingProps}
          />
        </Desktop>
        <Tablet>
          <ProductListing
            itemsPerRow={itemsPerRow.tablet}
            listingBannerRowProperty="row"
            listingBannerSizeProperty="size"
            listingBannerImageProperty="desktopImage"
            {...productListingProps}
          />
        </Tablet>
        <Mobile>
          <ProductListing
            itemsPerRow={itemsPerRow.mobile}
            listingBannerRowProperty="mobileRow"
            listingBannerSizeProperty="mobileSize"
            listingBannerImageProperty="mobileImage"
            {...productListingProps}
          />
        </Mobile>
      </MediaContextProvider>
    </>
  )
}

export default ProductsContainerRedesign
